export default class Logger {
    constructor(name = 'LOGGER') {
        this.name = name + ':';

        this.trace = !import.meta.env.PROD ? console.trace.bind(console, this.name) : () => {};
        this.d = !import.meta.env.PROD ? console.debug.bind(console, this.name) : () => {};
        this.m = console.log.bind(console, this.name);
        this.i = console.info.bind(console, this.name);
        this.w = console.warn.bind(console, this.name);
        this.e = console.error.bind(console, this.name);
    }
}